import { padStart } from 'lodash';

export function standardizeParcelId(parcelId) {
	//special tax account that got entered wrong in FY24
	//a numeric parcel ID loses its leading zeros
	if (parcelId === '0052098' || parcelId === 52098) {
		return '0052098';
	}
	return padStart(parcelId, 8, '0');
}

export function sdatLink(parcelId) {
	parcelId = standardizeParcelId(parcelId);
	//https://sdat.dat.maryland.gov/RealProperty/Pages/viewdetails.aspx?County=12&SearchType=ACCT&District=01&AccountNumber=001612
	let link = 'https://sdat.dat.maryland.gov/RealProperty/Pages/viewdetails.aspx?County=12&SearchType=ACCT&District=';
	link += parcelId.substring(0, 2);
	link += '&AccountNumber=' + parcelId.substring(2);
	return link;
}
